// This file is auto-generated by @hey-api/openapi-ts

import * as z from "zod";

export const zApiErrorDetail = z.object({
  detailMessages: z.array(z.string()),
});

export const zAreaResponseDto = z.object({
  areaId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  name: z.string(),
});

export const zAreaListResponseDto = z.object({
  areas: z.array(zAreaResponseDto),
});

export const zArticleDto = z.object({
  description: z.string().optional(),
  name: z.string().min(1),
  price: z.number().gte(0).optional(),
  sku: z.string().min(1),
});

export const zAssignContainersToAreaDto = z.object({
  containerIds: z
    .array(
      z
        .int()
        .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
        .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    )
    .min(1)
    .max(100),
});

export const zCompanyContactCreateDto = z.object({
  companyName: z.string().min(1),
});

export const zCompanyContactResponseDto = z.object({
  companyName: z.string(),
});

export const zConfirmationMailDto = z.object({
  name: z.string().min(1),
  to: z.string().min(1),
  token: z.uuid(),
});

export const zContactDetailAddressType = z.enum(["INVOICE", "DELIVERY"]);

export const zAddressResponseDto = z.object({
  addition: z.string().optional(),
  addressId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  addressType: zContactDetailAddressType,
  city: z.string().optional(),
  country: z.string(),
  postalCode: z.string().optional(),
  street: z.string().optional(),
});

export const zContactDetailEmailType = z.enum(["BUSINESS", "OFFICE", "PRIVATE", "OTHER"]);

export const zContactDetailPhoneNumberType = z.enum(["BUSINESS", "OFFICE", "MOBILE", "PRIVATE", "FAX", "OTHER"]);

export const zContactIdentifierCustomerResponseDto = z.object({
  customerId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
});

export const zContactIdentifierSupplierResponseDto = z.object({
  customerIdAtSupplier: z.string().optional(),
  supplierId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
});

export const zContactSyncResultDto = z.object({
  failureCount: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  hasFailures: z.boolean(),
  successCount: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  totalCount: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
});

export const zContactType = z.enum(["Company", "Individual"]);

export const zContainerCountByArea = z.object({
  areaId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
    .optional(),
  count: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
});

export const zContainerEmptyBatchDto = z.object({
  containerIds: z
    .array(
      z
        .int()
        .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
        .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    )
    .min(1)
    .max(1000),
  emptyingDate: z.iso.date().optional(),
  removeLocation: z.boolean().optional(),
});

export const zContentLevelEventStatisticDto = z.object({
  date: z.iso.date(),
  emptyVolume: z.number(),
  fillVolume: z.number(),
  stockVolume: z.number(),
});

export const zContentLevelEventStatisticsDto = z.object({
  contentLevelEventStatistics: z.array(zContentLevelEventStatisticDto),
  sumEmptyVolume: z.number(),
  sumFillVolume: z.number(),
});

export const zCreateAddressDto = z.object({
  addition: z.string().optional(),
  addressType: zContactDetailAddressType,
  city: z.string().optional(),
  country: z.string().min(1),
  postalCode: z.string().optional(),
  street: z.string().optional(),
});

export const zCreateAreaRequestDto = z.object({
  name: z.string().min(1),
});

export const zCreateContactIdentifierCustomerDto = z.object({
  customerId: z.int().gte(10000).lte(69999).optional(),
});

export const zCreateContactIdentifierSupplierDto = z.object({
  customerIdAtSupplier: z.string().optional(),
  supplierId: z.int().gte(70000).lte(99999).optional(),
});

export const zCreateContactResponseDto = z.object({
  contactId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
});

export const zCreateContainerRequestDto = z.object({
  containerName: z.string().min(1),
  containerTypeId: z.int().gte(1).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
});

export const zCreateContainerBatchRequestDto = z.object({
  containers: z.array(zCreateContainerRequestDto).min(1).max(100),
});

export const zCreateEmailDto = z.object({
  email: z.email().min(1),
  emailType: zContactDetailEmailType,
});

export const zCreatePhoneNumberDto = z.object({
  phoneNumber: z.string().min(1),
  phoneNumberType: zContactDetailPhoneNumberType,
});

export const zCuttingLength = z.enum(["CM25", "CM33"]);

export const zContainerCountByCuttingLength = z.object({
  count: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  cuttingLength: zCuttingLength,
});

export const zCuttingLengthDto = z.object({
  cuttingLength: zCuttingLength,
  cuttingLengthId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  name: z.string(),
});

export const zCuttingLengthContainerDto = z.object({
  cuttingLengths: z.array(zCuttingLengthDto),
});

export const zEmailResponseDto = z.object({
  email: z.string(),
  emailId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  emailType: zContactDetailEmailType,
});

export const zExternalSystem = z.enum(["LEXWARE"]);

export const zExternalReferenceDto = z.object({
  externalSyncId: z.string(),
  externalSyncImportError: z.string().optional(),
  externalSystem: zExternalSystem,
  externalVersion: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
    .optional(),
});

export const zExternalSystemSettingsResponseDto = z.object({
  id: z.string(),
  system: zExternalSystem,
  tokenLength: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
});

export const zHttpStatus = z.enum([
  "100 CONTINUE",
  "101 SWITCHING_PROTOCOLS",
  "102 PROCESSING",
  "103 EARLY_HINTS",
  "200 OK",
  "201 CREATED",
  "202 ACCEPTED",
  "203 NON_AUTHORITATIVE_INFORMATION",
  "204 NO_CONTENT",
  "205 RESET_CONTENT",
  "206 PARTIAL_CONTENT",
  "207 MULTI_STATUS",
  "208 ALREADY_REPORTED",
  "226 IM_USED",
  "300 MULTIPLE_CHOICES",
  "301 MOVED_PERMANENTLY",
  "302 FOUND",
  "303 SEE_OTHER",
  "304 NOT_MODIFIED",
  "307 TEMPORARY_REDIRECT",
  "308 PERMANENT_REDIRECT",
  "400 BAD_REQUEST",
  "401 UNAUTHORIZED",
  "402 PAYMENT_REQUIRED",
  "403 FORBIDDEN",
  "404 NOT_FOUND",
  "405 METHOD_NOT_ALLOWED",
  "406 NOT_ACCEPTABLE",
  "407 PROXY_AUTHENTICATION_REQUIRED",
  "408 REQUEST_TIMEOUT",
  "409 CONFLICT",
  "410 GONE",
  "411 LENGTH_REQUIRED",
  "412 PRECONDITION_FAILED",
  "413 CONTENT_TOO_LARGE",
  "413 PAYLOAD_TOO_LARGE",
  "414 URI_TOO_LONG",
  "415 UNSUPPORTED_MEDIA_TYPE",
  "416 REQUESTED_RANGE_NOT_SATISFIABLE",
  "417 EXPECTATION_FAILED",
  "418 I_AM_A_TEAPOT",
  "421 MISDIRECTED_REQUEST",
  "422 UNPROCESSABLE_CONTENT",
  "422 UNPROCESSABLE_ENTITY",
  "423 LOCKED",
  "424 FAILED_DEPENDENCY",
  "425 TOO_EARLY",
  "426 UPGRADE_REQUIRED",
  "428 PRECONDITION_REQUIRED",
  "429 TOO_MANY_REQUESTS",
  "431 REQUEST_HEADER_FIELDS_TOO_LARGE",
  "451 UNAVAILABLE_FOR_LEGAL_REASONS",
  "500 INTERNAL_SERVER_ERROR",
  "501 NOT_IMPLEMENTED",
  "502 BAD_GATEWAY",
  "503 SERVICE_UNAVAILABLE",
  "504 GATEWAY_TIMEOUT",
  "505 HTTP_VERSION_NOT_SUPPORTED",
  "506 VARIANT_ALSO_NEGOTIATES",
  "507 INSUFFICIENT_STORAGE",
  "508 LOOP_DETECTED",
  "509 BANDWIDTH_LIMIT_EXCEEDED",
  "510 NOT_EXTENDED",
  "511 NETWORK_AUTHENTICATION_REQUIRED",
]);

export const zHttpStatusCode = z.object({
  error: z.boolean().optional(),
  is1xxInformational: z.boolean().optional(),
  is2xxSuccessful: z.boolean().optional(),
  is3xxRedirection: z.boolean().optional(),
  is4xxClientError: z.boolean().optional(),
  is5xxServerError: z.boolean().optional(),
});

export const zDefaultHttpStatusCode = zHttpStatusCode;

export const zHumidityLevel = z.enum(["WET", "PRE_DRIED", "DRIED"]);

export const zContainerCountByHumidityLevel = z.object({
  count: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  humidityLevel: zHumidityLevel,
});

export const zHumidityLevelDto = z.object({
  humidityLevel: zHumidityLevel,
  humidityLevelId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  name: z.string(),
});

export const zHumidityLevelContainerDto = z.object({
  humidityLevels: z.array(zHumidityLevelDto),
});

export const zIndividualContactCreateDto = z.object({
  firstName: z.string().optional(),
  lastName: z.string().min(1),
  salutation: z.string().optional(),
});

export const zContactCreateDto = z.object({
  addresses: z.array(zCreateAddressDto),
  companyContact: zCompanyContactCreateDto.optional(),
  contactIdentifierCustomer: zCreateContactIdentifierCustomerDto.optional(),
  contactIdentifierSupplier: zCreateContactIdentifierSupplierDto.optional(),
  contactType: zContactType,
  emails: z.array(zCreateEmailDto),
  externalReference: zExternalReferenceDto.optional(),
  individualContact: zIndividualContactCreateDto.optional(),
  note: z.string().optional(),
  phoneNumbers: z.array(zCreatePhoneNumberDto),
});

export const zIndividualContactResponseDto = z.object({
  firstName: z.string().optional(),
  lastName: z.string(),
  salutation: z.string().optional(),
});

export const zLevelEventType = z.enum(["FILL", "EMPTY"]);

export const zContentLevelBatchDto = z.object({
  containerIds: z
    .array(
      z
        .int()
        .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
        .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    )
    .min(1)
    .max(100),
  date: z.iso.date(),
  eventType: zLevelEventType,
  volume: z.number().gte(0),
});

export const zLink = z.object({
  href: z.string().optional(),
  templated: z.boolean().optional(),
});

export const zOrderDeliveryScheduleDto = z.object({
  deliveryDate: z.iso.date(),
  deliveryTime: z.string(),
  duration: z.string(),
  orderNumber: z.string().min(1),
});

export const zOrderItemCreateDto = z.object({
  price: z.number(),
  priceOverride: z.number().optional(),
  type: z.string(),
});

export const zOrderItemArticleCreateDto = zOrderItemCreateDto.and(
  z.object({
    description: z.string().optional(),
    name: z.string().min(1),
    price: z.number().gte(0),
    priceOverride: z.number().gte(0).optional(),
    quantity: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    sku: z.string().min(1),
    type: z.literal("OrderItemArticleCreateDto"),
  }),
);

export const zOrderItemDto = z.object({
  orderItemId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  price: z.number(),
  priceOverride: z.number().optional(),
  type: z.string(),
});

export const zOrderItemArticleDto = zOrderItemDto.and(
  z.object({
    description: z.string().optional(),
    name: z.string().min(1),
    price: z.number().gte(0),
    priceOverride: z.number().gte(0).optional(),
    quantity: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    sku: z.string().min(1),
    type: z.literal("OrderItemArticleDto"),
  }),
);

export const zOrderItemUpdateDto = z.object({
  price: z.number(),
  priceOverride: z.number().optional(),
  type: z.string(),
});

export const zOrderItemArticleUpdateDto = zOrderItemUpdateDto.and(
  z.object({
    description: z.string().optional(),
    name: z.string().min(1),
    orderItemId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    price: z.number().gte(0),
    priceOverride: z.number().gte(0).optional(),
    quantity: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    sku: z.string().min(1),
    type: z.literal("OrderItemArticleUpdateDto"),
  }),
);

export const zOrderStatus = z.enum([
  "NEW",
  "SCHEDULED",
  "IN_DELIVERY",
  "DELIVERED",
  "CANCELED",
  "UNSCHEDULED",
  "RESCHEDULED",
]);

export const zPasswordResetConfirmationRequestDto = z.object({
  password: z.string().min(1),
  token: z.uuid(),
});

export const zPasswordResetRequestDto = z.object({
  username: z.email().min(1),
});

export const zPhoneNumberResponseDto = z.object({
  phoneNumber: z.string(),
  phoneNumberId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  phoneNumberType: zContactDetailPhoneNumberType,
});

export const zContactResponseDto = z.object({
  addresses: z.array(zAddressResponseDto),
  companyContact: zCompanyContactResponseDto.optional(),
  contactId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  contactIdentifierCustomer: zContactIdentifierCustomerResponseDto.optional(),
  contactIdentifierSupplier: zContactIdentifierSupplierResponseDto.optional(),
  contactType: zContactType,
  emails: z.array(zEmailResponseDto),
  externalReference: zExternalReferenceDto.optional(),
  individualContact: zIndividualContactResponseDto.optional(),
  note: z.string().optional(),
  phoneNumbers: z.array(zPhoneNumberResponseDto),
});

export const zPriceDto = z.object({
  cuttingLengthId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  humidityLevelId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  price: z.number(),
  priceOverride: z.number().optional(),
  woodTypeId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
});

export const zPriceContainerDto = z.object({
  prices: z.array(zPriceDto),
});

export const zPriceModifierCuttingLengthDto = z.object({
  cuttingLengthId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  value: z.number().optional(),
});

export const zPriceModifierHumidityLevelDto = z.object({
  humidityLevelId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  value: z.number().optional(),
});

export const zPriceModifierWoodTypeDto = z.object({
  value: z.number().optional(),
  woodTypeId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
});

export const zPriceOverrideDto = z.object({
  cuttingLengthId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  humidityLevelId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  value: z.number(),
  woodTypeId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
});

export const zPriceOverrideContainerDto = z.object({
  overrides: z.array(zPriceOverrideDto),
});

export const zPriceSettingsDto = z.object({
  basePrice: z.number().optional(),
  priceModifiersCuttingLength: z.array(zPriceModifierCuttingLengthDto),
  priceModifiersHumidityLevel: z.array(zPriceModifierHumidityLevelDto),
  priceModifiersWoodType: z.array(zPriceModifierWoodTypeDto),
});

export const zPriceSettingsRequestDto = z.object({
  basePrice: z.number().gte(0).optional(),
  priceModifiersCuttingLength: z.array(zPriceModifierCuttingLengthDto),
  priceModifiersHumidityLevel: z.array(zPriceModifierHumidityLevelDto),
  priceModifiersWoodType: z.array(zPriceModifierWoodTypeDto),
});

export const zResponseMetadata = z.object({
  spanId: z.string(),
  timestamp: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" })
    .max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }),
  traceId: z.string(),
});

export const zApiErrorContainer = z.object({
  code: z.string(),
  details: z.array(zApiErrorDetail),
  message: z.string(),
  metadata: zResponseMetadata,
  status: z.union([zDefaultHttpStatusCode, zHttpStatus]),
});

export const zApiResponseContactSyncResultDto = z.object({
  data: zContactSyncResultDto,
  metadata: zResponseMetadata,
});

export const zApiResponseExternalSystemSettingsResponseDto = z.object({
  data: zExternalSystemSettingsResponseDto,
  metadata: zResponseMetadata,
});

export const zApiResponseInteger = z.object({
  data: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  metadata: zResponseMetadata,
});

export const zApiResponseListArticleDto = z.object({
  data: z.array(zArticleDto),
  metadata: zResponseMetadata,
});

export const zApiResponseListExternalSystemSettingsResponseDto = z.object({
  data: z.array(zExternalSystemSettingsResponseDto),
  metadata: zResponseMetadata,
});

export const zApiResponseListOrderDeliveryScheduleDto = z.object({
  data: z.array(zOrderDeliveryScheduleDto),
  metadata: zResponseMetadata,
});

export const zApiResponseString = z.object({
  data: z.string(),
  metadata: zResponseMetadata,
});

export const zApiResponseUnit = z.object({
  metadata: zResponseMetadata,
});

export const zSignInRequestDto = z.object({
  password: z.string().min(1),
  username: z.string().min(1),
});

export const zSignUpRequestDto = z.object({
  companyName: z.string().min(1),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  password: z.string().min(1),
  username: z.email().min(1),
});

export const zStoreExternalSystemSettingsRequestDto = z.object({
  system: zExternalSystem,
  token: z.string().min(1),
});

export const zUnitOfMeasurement = z.enum(["SOLID_CUBIC_METER", "STACKED_CUBIC_METER", "LOOSE_CUBIC_METER"]);

export const zContainerTypeRequestDto = z.object({
  name: z.string().min(1),
  unitOfMeasurement: zUnitOfMeasurement,
  volume: z.number(),
});

export const zContainerTypeResponseDto = z.object({
  containerTypeId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  name: z.string(),
  unitOfMeasurement: zUnitOfMeasurement,
  volume: z.number(),
});

export const zContainerTypeListResponseDto = z.object({
  containerTypes: z.array(zContainerTypeResponseDto),
});

export const zOrderItemWoodCreateDto = zOrderItemCreateDto.and(
  z.object({
    cuttingLengthId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    humidityLevelId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    price: z.number().gte(0),
    priceOverride: z.number().gte(0).optional(),
    unitOfMeasurement: zUnitOfMeasurement,
    volume: z.number().gte(0),
    woodTypeId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    type: z.literal("OrderItemWoodCreateDto"),
  }),
);

export const zOrderCreateDto = z.object({
  contactId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  deliveryAddress: z.string().optional(),
  deliveryDate: z.iso.date().optional(),
  deliveryTargetDateEnd: z.iso.date().optional(),
  deliveryTargetDateStart: z.iso.date(),
  deliveryTargetTimeEnd: z.string().optional(),
  deliveryTargetTimeStart: z.string().optional(),
  invoiceAddress: z.string().min(1),
  items: z
    .array(z.union([zOrderItemArticleCreateDto, zOrderItemWoodCreateDto]))
    .min(1)
    .max(2147483647),
  orderDate: z.iso.date(),
  status: zOrderStatus.optional(),
});

export const zOrderItemWoodDto = zOrderItemDto.and(
  z.object({
    cuttingLengthId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    humidityLevelId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    price: z.number().gte(0),
    priceOverride: z.number().gte(0).optional(),
    unitOfMeasurement: zUnitOfMeasurement,
    volume: z.number().gte(0),
    woodTypeId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    type: z.literal("OrderItemWoodDto"),
  }),
);

export const zOrderDto = z.object({
  contactId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  deliveryAddress: z.string().optional(),
  deliveryDate: z.iso.date().optional(),
  deliverySchedule: zOrderDeliveryScheduleDto.optional(),
  deliveryTargetDateEnd: z.iso.date().optional(),
  deliveryTargetDateStart: z.iso.date(),
  deliveryTargetTimeEnd: z.string().optional(),
  deliveryTargetTimeStart: z.string().optional(),
  invoiceAddress: z.string().min(1),
  items: z
    .array(z.union([zOrderItemArticleDto, zOrderItemWoodDto]))
    .min(1)
    .max(2147483647),
  orderDate: z.iso.date(),
  orderNumber: z.string(),
  status: zOrderStatus,
  totalPrice: z.number(),
  totalPriceOverride: z.number().optional(),
});

export const zApiResponseListOrderDto = z.object({
  data: z.array(zOrderDto),
  metadata: zResponseMetadata,
});

export const zApiResponseOrderDto = z.object({
  data: zOrderDto,
  metadata: zResponseMetadata,
});

export const zOrderItemWoodUpdateDto = zOrderItemUpdateDto.and(
  z.object({
    cuttingLengthId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    humidityLevelId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    orderItemId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .optional(),
    price: z.number().gte(0),
    priceOverride: z.number().gte(0).optional(),
    unitOfMeasurement: zUnitOfMeasurement,
    volume: z.number().gte(0),
    woodTypeId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    type: z.literal("OrderItemWoodUpdateDto"),
  }),
);

export const zOrderUpdateDto = z.object({
  contactId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  deliveryAddress: z.string().optional(),
  deliveryDate: z.iso.date().optional(),
  deliveryTargetDateEnd: z.iso.date().optional(),
  deliveryTargetDateStart: z.iso.date(),
  deliveryTargetTimeEnd: z.string().optional(),
  deliveryTargetTimeStart: z.string().optional(),
  invoiceAddress: z.string().min(1),
  items: z
    .array(z.union([zOrderItemArticleUpdateDto, zOrderItemWoodUpdateDto]))
    .min(1)
    .max(2147483647),
  orderDate: z.iso.date(),
  orderNumber: z.string().min(1),
  status: zOrderStatus,
});

export const zUpdateContainerTypeRequestDto = z.object({
  adjustLevel: z.boolean(),
  containerTypeId: z.int().gte(1).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
});

export const zUpdateExternalSystemSettingsRequestDto = z.object({
  token: z.string().min(1),
});

export const zUserDto = z.object({
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  roles: z.array(z.string()),
  tenantId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  userId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
});

export const zVersionResponseDto = z.object({
  buildVersion: z.string(),
  octalogVersion: z.string(),
});

export const zVolumeByArea = z.object({
  areaId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
    .optional(),
  volume: z.number(),
});

export const zAreaStatistics = z.object({
  containerCountByArea: z.array(zContainerCountByArea),
  sum: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  volumeByArea: z.array(zVolumeByArea),
});

export const zVolumeByCuttingLength = z.object({
  cuttingLength: zCuttingLength,
  volume: z.number(),
});

export const zCuttingLengthStatistics = z.object({
  containerCountByCuttingLength: z.array(zContainerCountByCuttingLength),
  sum: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  volumeByCuttingLength: z.array(zVolumeByCuttingLength),
});

export const zVolumeByHumidityLevel = z.object({
  humidityLevel: zHumidityLevel,
  volume: z.number(),
});

export const zHumidityLevelStatistics = z.object({
  containerCountByHumidityLevel: z.array(zContainerCountByHumidityLevel),
  sum: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  volumeByHumidityLevel: z.array(zVolumeByHumidityLevel),
});

export const zWoodType = z.enum(["BEECH", "OAK", "SPRUCE", "ASH", "LARCH"]);

export const zAddContentRequestDto = z.object({
  cuttingLength: zCuttingLength,
  fillingDate: z.iso.date(),
  humidityLevel: zHumidityLevel,
  level: z.number().gte(0).optional(),
  woodType: zWoodType,
});

export const zContainerAddContentBatchDto = z.object({
  containerIds: z
    .array(
      z
        .int()
        .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
        .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    )
    .min(1),
  content: zAddContentRequestDto,
});

export const zContainerCountByWoodType = z.object({
  count: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  woodType: zWoodType,
});

export const zGetContentResponseDto = z.object({
  contentId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  cuttingLength: zCuttingLength,
  fillingDate: z.iso.date(),
  humidityLevel: zHumidityLevel,
  level: z.number(),
  woodType: zWoodType,
});

export const zGetContainerResponseDto = z.object({
  area: zAreaResponseDto.optional(),
  containerId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  containerName: z.string(),
  containerType: zContainerTypeResponseDto,
  content: zGetContentResponseDto.optional(),
});

export const zGetContainerListResponseDto = z.object({
  containers: z.array(zGetContainerResponseDto),
});

export const zUpdateContentRequestDto = z.object({
  cuttingLength: zCuttingLength,
  humidityLevel: zHumidityLevel,
  woodType: zWoodType,
});

export const zUpdateContainerRequestDto = z.object({
  areaId: z.int().gte(1).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).optional(),
  containerName: z.string().optional(),
  containerType: zUpdateContainerTypeRequestDto.optional(),
  content: zUpdateContentRequestDto.optional(),
});

export const zVolumeByWoodType = z.object({
  volume: z.number(),
  woodType: zWoodType,
});

export const zWoodTypeDto = z.object({
  name: z.string(),
  woodType: zWoodType,
  woodTypeId: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
});

export const zWoodTypeContainerDto = z.object({
  woodTypes: z.array(zWoodTypeDto),
});

export const zWoodTypeStatistics = z.object({
  containerCountByWoodType: z.array(zContainerCountByWoodType),
  sum: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  volumeByWoodType: z.array(zVolumeByWoodType),
});

export const zContainerStatisticsDto = z.object({
  areaStatistics: zAreaStatistics,
  containerCountEmpty: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  containerCountFull: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  containerCountSum: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  cuttingLengthStatistics: zCuttingLengthStatistics,
  humidityLevelStatistics: zHumidityLevelStatistics,
  woodTypeStatistics: zWoodTypeStatistics,
});

export const zLinksData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zLinksResponse = z.record(z.string(), z.record(z.string(), zLink));

export const zHealthData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zHealthResponse = z.record(z.string(), z.unknown());

export const zInfoData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zInfoResponse = z.record(z.string(), z.unknown());

export const zGetAreasData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetAreasResponse = zAreaListResponseDto;

export const zCreateAreaData = z.object({
  body: zCreateAreaRequestDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zCreateAreaResponse = zAreaResponseDto;

export const zGetAreaByIdData = z.object({
  body: z.never().optional(),
  path: z.object({
    areaId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  }),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetAreaByIdResponse = zAreaResponseDto;

export const zUpdateAreaData = z.object({
  body: zCreateAreaRequestDto,
  path: z.object({
    areaId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  }),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zUpdateAreaResponse = zAreaResponseDto;

export const zAssignContainerToAreaData = z.object({
  body: z.never().optional(),
  path: z.object({
    areaId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
    containerId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  }),
  query: z.never().optional(),
});

export const zAssignContainersToAreaData = z.object({
  body: zAssignContainersToAreaDto,
  path: z.object({
    areaId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  }),
  query: z.never().optional(),
});

export const zListArticlesData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zListArticlesResponse = zApiResponseListArticleDto;

export const zCreateArticleData = z.object({
  body: zArticleDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zCreateArticleResponse = zApiResponseInteger;

export const zGetContactsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetContactsResponse = z.array(zContactResponseDto);

export const zCreateContactData = z.object({
  body: zContactCreateDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Created
 */
export const zCreateContactResponse = zCreateContactResponseDto;

export const zGetContactByIdData = z.object({
  body: z.never().optional(),
  path: z.object({
    contactId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  }),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetContactByIdResponse = zContactResponseDto;

export const zUpdateContactByIdData = z.object({
  body: zContactCreateDto,
  path: z.object({
    contactId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  }),
  query: z.never().optional(),
});

export const zGetContainerTypesData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetContainerTypesResponse = zContainerTypeListResponseDto;

export const zCreateContainerTypeData = z.object({
  body: zContainerTypeRequestDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zCreateContainerTypeResponse = zContainerTypeResponseDto;

export const zDeleteContainerTypeData = z.object({
  body: z.never().optional(),
  path: z.object({
    containerTypeId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  }),
  query: z.never().optional(),
});

export const zGetContainerTypeData = z.object({
  body: z.never().optional(),
  path: z.object({
    containerTypeId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  }),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetContainerTypeResponse = zContainerTypeResponseDto;

export const zUpdateContainerTypeData = z.object({
  body: zContainerTypeRequestDto,
  path: z.object({
    containerTypeId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  }),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zUpdateContainerTypeResponse = zContainerTypeResponseDto;

export const zGetContainersData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      containerIds: z
        .array(
          z
            .int()
            .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
            .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
        )
        .optional(),
      containerNames: z.array(z.string()).optional(),
    })
    .optional(),
});

/**
 * OK
 */
export const zGetContainersResponse = zGetContainerListResponseDto;

export const zCreateContainerData = z.object({
  body: zCreateContainerRequestDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zCreateContainerResponse = zGetContainerResponseDto;

export const zCreateContainersData = z.object({
  body: zCreateContainerBatchRequestDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zCreateContainersResponse = zGetContainerListResponseDto;

export const zGetContainerByIdData = z.object({
  body: z.never().optional(),
  path: z.object({
    containerId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  }),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetContainerByIdResponse = zGetContainerResponseDto;

export const zUpdateContainerData = z.object({
  body: zUpdateContainerRequestDto,
  path: z.object({
    containerId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  }),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zUpdateContainerResponse = zGetContainerResponseDto;

export const zAddContentToContainerData = z.object({
  body: zAddContentRequestDto,
  path: z.object({
    containerId: z
      .int()
      .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  }),
  query: z.never().optional(),
});

export const zDeleteContentBatchWithoutCheckData = z.object({
  body: zContainerEmptyBatchDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zDeleteContentBatchWithoutCheckResponse = zGetContainerListResponseDto;

export const zAddContentToContainerBatchData = z.object({
  body: zContainerAddContentBatchDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zAddContentToContainerBatchResponse = zGetContainerListResponseDto;

export const zChangeContentLevelBatchData = z.object({
  body: zContentLevelBatchDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zChangeContentLevelBatchResponse = zGetContainerListResponseDto;

export const zListExternalSystemsSettingsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zListExternalSystemsSettingsResponse = zApiResponseListExternalSystemSettingsResponseDto;

export const zStoreExternalSystemSettingsData = z.object({
  body: zStoreExternalSystemSettingsRequestDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * Created
 */
export const zStoreExternalSystemSettingsResponse = zApiResponseExternalSystemSettingsResponseDto;

export const zTriggerSyncData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zTriggerSyncResponse = zApiResponseContactSyncResultDto;

export const zDeleteExternalSystemSettingsData = z.object({
  body: z.never().optional(),
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * No Content
 */
export const zDeleteExternalSystemSettingsResponse = zApiResponseUnit;

export const zUpdateExternalSystemSettingsData = z.object({
  body: zUpdateExternalSystemSettingsRequestDto,
  path: z.object({
    id: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zUpdateExternalSystemSettingsResponse = zApiResponseExternalSystemSettingsResponseDto;

export const zGetMeData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetMeResponse = zUserDto;

export const zStartPasswordResetData = z.object({
  body: zPasswordResetRequestDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

export const zConfirmPasswordResetData = z.object({
  body: zPasswordResetConfirmationRequestDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

export const zSignInData = z.object({
  body: zSignInRequestDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zSignInResponse = zApiErrorContainer;

export const zSignOutData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

export const zSignUpData = z.object({
  body: zSignUpRequestDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

export const zConfirmSignUpData = z.object({
  body: z.never().optional(),
  path: z.object({
    token: z.uuid(),
  }),
  query: z.never().optional(),
});

export const zGetVersionData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetVersionResponse = zVersionResponseDto;

export const zSendConfirmationMailData = z.object({
  body: zConfirmationMailDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

export const zGetOrdersData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      scheduledDeliveryDateFrom: z.iso.date().optional(),
      scheduledDeliveryDateTo: z.iso.date().optional(),
    })
    .optional(),
});

/**
 * OK
 */
export const zGetOrdersResponse = zApiResponseListOrderDto;

export const zCreateOrderData = z.object({
  body: zOrderCreateDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zCreateOrderResponse = zApiResponseString;

export const zUnscheduleDeliveryData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.object({
    orderNumber: z.string(),
  }),
});

/**
 * OK
 */
export const zUnscheduleDeliveryResponse = zApiResponseUnit;

export const zGetDeliveryScheduleData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.object({
    startDate: z.iso.date(),
    endDate: z.iso.date(),
  }),
});

/**
 * OK
 */
export const zGetDeliveryScheduleResponse = zApiResponseListOrderDeliveryScheduleDto;

export const zScheduleDeliveryData = z.object({
  body: zOrderDeliveryScheduleDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zScheduleDeliveryResponse = zApiResponseUnit;

export const zGetOrderData = z.object({
  body: z.never().optional(),
  path: z.object({
    orderNumber: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetOrderResponse = zApiResponseOrderDto;

export const zUpdateOrderData = z.object({
  body: zOrderUpdateDto,
  path: z.object({
    orderNumber: z.string(),
  }),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zUpdateOrderResponse = zApiResponseUnit;

export const zGetPriceOverridesData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetPriceOverridesResponse = zPriceOverrideContainerDto;

export const zSetPriceOverridesData = z.object({
  body: zPriceOverrideContainerDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

export const zGetPriceSettingsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetPriceSettingsResponse = zPriceSettingsDto;

export const zSetPriceSettingsData = z.object({
  body: zPriceSettingsRequestDto,
  path: z.never().optional(),
  query: z.never().optional(),
});

export const zGetPricesData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetPricesResponse = zPriceContainerDto;

export const zGetCuttingLengthsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetCuttingLengthsResponse = zCuttingLengthContainerDto;

export const zGetHumidityLevelsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetHumidityLevelsResponse = zHumidityLevelContainerDto;

export const zGetWoodTypesData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetWoodTypesResponse = zWoodTypeContainerDto;

export const zGetContainerStatisticsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z.never().optional(),
});

/**
 * OK
 */
export const zGetContainerStatisticsResponse = zContainerStatisticsDto;

export const zGetContentLevelEventStatisticsData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      withNulls: z.boolean().optional(),
      startDate: z.iso.date().optional(),
      endDate: z.iso.date().optional(),
    })
    .optional(),
});

/**
 * OK
 */
export const zGetContentLevelEventStatisticsResponse = zContentLevelEventStatisticsDto;
